export default __webpack_public_path__ + "static/media/banner-driver-wheel.1bf8abbf.png";